<template>
  <v-menu v-model="open" top :close-on-content-click="false" :offset-y="true">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-on="on" v-bind="attrs" small color="deep-purple darken-2" dark class="mr-3">
        <v-icon left>mdi-gesture-tap-button</v-icon>
        {{ title }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="deep-purple pt-2 pb-2 mb-5">
        <div class="text-subtitle-1 white--text">{{ title }}</div>
      </v-card-title>
      <v-card-text>
        <v-text-field solo dense v-model="text">
          <template v-slot:prepend-inner>
            <v-chip color="deep-purple" style="left:-10px" label dark>{{ $t("SLIDER.DETAIL.SLIDER_BUTTONS.TEXT") }}: </v-chip>
          </template>
        </v-text-field>
        <v-text-field solo dense hide-details v-model="link">
          <template v-slot:prepend-inner>
            <v-chip color="deep-purple" style="left:-10px" label dark>{{ $t("SLIDER.DETAIL.SLIDER_BUTTONS.LINK") }}: </v-chip>
          </template>
        </v-text-field>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="grey lighten-4">
        <v-btn small color="success darken-1" class="d-block ml-auto text-capitalize" @click="open = false">
          <v-icon size="15" class="mr-1">mdi-check</v-icon>
          {{ $t("SLIDER.DETAIL.SLIDER_BUTTONS.OK_BTN") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "SliderButton",
  props: {
    text: {
      required: true,
      type: String,
      default: ""
    },
    link: {
      required: true,
      type: String,
      default: ""
    },
    title: {
      required: true,
      type: String,
      default: ""
    }
  },
  data: () => ({
    open: false
  }),
  watch: {
    text(val) {
      this.$emit("text", val);
    },
    link(val) {
      this.$emit("link", val);
    }
  }
};
</script>

<style></style>
